import { render, staticRenderFns } from "./EdenServicesList.vue?vue&type=template&id=030d3197"
import script from "./EdenServicesList.vue?vue&type=script&lang=js"
export * from "./EdenServicesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports